import Handlebars from 'handlebars';
import { toJS } from 'mobx';

Handlebars.registerHelper(
  'if_eq',
  function(a, b, options) {
    return (a === b) ? options.fn(this) : options.inverse(this);
  });

function separator(body, elm) {
  //console.log(body, elm);
  const index = body.indexOf(elm);
  if (index === body.length-2)
    return '; and';
  else if (elm.indent === 1 && index === body.length-1) // last one
    return '.';
  else if (elm.children.length === 0)
    return ';';
  else
    return '';
}

Handlebars.registerHelper('separator', separator);

function entity(claim) {
 const str = claim.entity();
  return str || '[ERROR: No entity]'
}

Handlebars.registerHelper('entity', entity);

Handlebars.registerHelper('arrow', function(claim) {
  return String.fromCharCode(8595)
});

Handlebars.registerHelper('up', function(txt) {
  return txt && txt.length > 0 ? txt.charAt(0).toUpperCase() + txt.slice(1) : '';
});

function color (claim, txt, doColor) {
  if (!claim.aliceScore || !doColor) {
    return txt;
  }
  const features = claim.aliceScore.features;
  const words = txt.split(' ');
  let result = ''
  for (const w of words) {
    //console.log('RESTULT', result);
    const weight = features[w]
    //console.log(w, weight, claim.hlThreshold);
    if (!weight || Math.abs(weight) < claim.hlThreshold) {
      result = result + ' ' + w;
    }
    else if (weight > claim.hlThreshold) {
      result = result + ` <span style="background-color: salmon">${w}</span>`
    }
    else {
      result = result + ` <span style="background-color: springgreen">${w}</span>`
    }
  }
  return result;
}

Handlebars.registerHelper('color', color);

function childRefs (children) {
  const last = children.length-1;
  if (last === -1) return 'NO_CHILDREN';
  if (last === 0) return children[0].refNum;
  return `${children[0].refNum}-${children[last].refNum}` 
}

Handlebars.registerHelper('childRefs', childRefs);

function childNames (children)  {
  const last = children.length-1;
  if (last === 0)
    return `${children[0].shortText} ${children[0].refNum}`;
  if (last === 1) return `${children[0].shortText} ${children[0].refNum} and $children[1].shortText} ${children[1].refNum}` 
  return children.reduce(
    (acc, node, idx) =>
      acc + (idx === last ? `and ${node.shortText} ${node.refNum}` : `${node.shortText} ${node.refNum}, `),'');
}


Handlebars.registerHelper('childNames', childNames);

// This is to handle properly indenting for Word b/c it only uses inches as units...
function indenter(level, target) {
  //console.log(level, target);
  return target === 'word' ? (level / 2) + 'in' : level + 'em';
}

Handlebars.registerHelper('indenter', indenter);

// {{log figType}}

// -------------------------------------------------------------------------------------
// Drawings
// -------------------------------------------------------------------------------------

const drawingTemplateText =`
{{#*inline "render_body"}}
  {{#each body}}
    {{#if_eq ../figType 'process'}}
      <div style="border: 1px solid black; padding: 0.5em; margin: 0 0.5em">
        <span style="text-decoration: underline; font-style: italic">{{this.refNum}}</span>: {{up this.shortText~}}
    {{else}}
      <div style="border: 1px solid black; padding: 0.5em; margin: 0.5em">
        <span style="text-decoration: underline; font-style: italic">{{this.refNum}}</span>: {{up this.shortText~}}
    {{/if_eq}}
     
    {{> render_body body=this.children figType=../figType}}
    </div>
   {{#if_eq ../figType 'process'}}
     {{#unless @last}}
       <div style="text-align: center; font-size: 1.5em; margin: 0; padding: 0">{{arrow}}</div>
     {{/unless}}
   {{/if_eq}}
  {{/each}}
{{/inline}}

{{#*inline "render_claim"}}
{{#if claim.drawFig}}
<div>
<center 
  style="font-size: 1.2em; font-style: italic; font-weight: bold; margin-top: 1em">
    Fig. {{claim.figNum}}
</center>
<div style="border: 1px solid black; margin: 0.5em; padding: 0.5em">
  <div style="margin-bottom: 0.5em">
  {{#if_eq claim.claimType 'ind'}}
      <span style="text-decoration: underline; font-style: italic">{{claim.tree.refNum}}</span>: 
         {{#if_eq claim.figType 'process'}}Process {{claim.tree.shortText}}{{else}}{{up claim.claimClass}}{{/if_eq}}
  {{else}}
    <span style="text-decoration: underline; font-style: italic">{{claim.tree.refNum}}</span>:
    {{#if_eq claim.figType 'process'}}Process{{else}}{{up claim.claimClass}}{{/if_eq}}
    <span style="font-style: italic">{{claim.parent.tree.refNum}}</span>, 
    {{#if_eq claim.claimType 'dep/fc'}}
      {{claim.tree.preamble}} 
    {{else}}
      wherein the {{entity claim}} {{claim.tree.preamble}}{{#unless claim.tree.children.length}}.{{/unless}}
    {{/if_eq}}
  {{/if_eq}}
  </div>
  {{> render_body body=this.tree.children figType=claim.figType}}
</div>
</div>
{{#each claim.children}}
  {{> render_claim claim=this}}
{{/each}}
{{/if}}
{{/inline}}

<div id='cws-figures'>
{{#if heading}}<h3>{{heading}}</h3>{{/if}}
{{#each claimSet.children}}
  {{> render_claim claim=this}}
{{/each}}
</div>
`;

export const drawingTemplate = Handlebars.compile(drawingTemplateText);

// -------------------------------------------------------------------------------------
// Written Description
// -------------------------------------------------------------------------------------

// return a list of body strings
const wdBody = (body, figType) => {
  let list = [];
  let traverse = (children) => {
    for (const elm of children) {
      let txt = '';
      if (figType === 'process') {
        txt = `Block ${elm.refNum} includes ${elm.text}`;
        txt += elm.children.length ? ` performing block(s) ${childRefs(elm.children)} described below. ` : '. ';
      }
      else { 
        txt = `Block ${elm.refNum} is ${elm.text}`;
        txt += elm.children.length ? ` block(s) ${childRefs(elm.children)} described below. ` : '. ';
      }
      txt += elm.wdText;
      list.push(txt);
      traverse(elm.children);
    }
  };
  traverse(body);
  return list;
};

Handlebars.registerHelper('wdBody', wdBody);

const paraIntro = (claim) => {
  let txt = `Figure ${claim.figNum} is a `;
  if (claim.claimType === 'ind' && claim.figType === 'process') 
    txt +=`flow diagram of example logic for ${claim.tree.shortText}. ${claim.tree.wdText} Figure ${claim.figNum} illustrates a process ${claim.tree.refNum} that includes block(s) ${childRefs(claim.tree.children)} described below. `;
  else if (claim.claimType === 'ind')
    txt += `block diagram of an example ${claim.claimClass} ${claim.tree.refNum}. ${claim.tree.wdText} The ${claim.claimClass} ${claim.tree.refNum} includes block(s) ${childRefs(claim.tree.children)} described below.`;
  else {
    txt += `block diagram of example logic that extends the module ${claim.parent.tree.refNum} of Figure ${claim.parent.tree.figNum}. ${claim.tree.wdText} More specifically, Figure ${claim.figNum} illustrates a process ${claim.tree.refNum} `;
    txt += claim.claimType === 'dep/fc' ? 'and which further includes the following block(s).' :
      `wherein the ${entity(claim)} includes the following block(s).`;
  }
  return txt;
};

Handlebars.registerHelper('paraIntro', paraIntro);

const wdTemplateText =`
{{#*inline "render_claim"}}
{{#if claim.drawFig}}
  <div style="text-indent: 1em">
  {{paraIntro claim}}
  </div>
  {{#each (wdBody claim.tree.children figType)}}
    <div style="text-indent: 1em">{{this}}</div>
  {{/each}}
  {{#each claim.children}}
    {{> render_claim claim=this}}
  {{/each}}
{{/if}}
{{/inline}}

<div id='cws-wd'>
{{#if heading}}<h3>{{heading}}</h3>{{/if}}
{{#each claimSet.children}}
  {{> render_claim claim=this}}
{{/each}}
</div>
`;

export const wdTemplate = Handlebars.compile(wdTemplateText);

const claim2WdJSON = (claim) => {
  if (!claim.drawFig) return [];
  let preamble = {indent: 0, text: paraIntro(claim)};
  let list = [ preamble ];
  for (const para of wdBody(claim.tree.children, claim.figType)) {
    list.push({indent: 0, text: para});
  }
  for (const childClaim of claim.children) {
    let items = claim2WdJSON(childClaim);
    list = list.concat(items);
  }
  return list;
}

export const wd2JSON = (claimset) => {
  let list = [];
  for (const claim of claimset.children)
    list = list.concat(claim2WdJSON(claim));
  return list;
}



// -------------------------------------------------------------------------------------
// Claims
// -------------------------------------------------------------------------------------

// recursively render the body to HTML
// Handlebars.registerHelper(
//   'renderBodyForClaim',
//   function renderBodyForClaim (claim, body, target, doColor) {
//     return !body ? '' : body.reduce((a, b) => {
//       return a + `<div style="margin: 0; text-indent: ${b.indent}em">${color(claim, b.text, doColor)}${separator(body, b)}</div>` +
//         renderBodyForClaim(claim, b.children, target);}, '');
//   }
// );

// Render into a flat list of JSON objects {indent: n, text: str}
// This can be used to create HTML or JSON for export to Word.
// The main thing here is to add the semicolons and 'and' properly
function renderBodyToJson (claim, body, target, doColor) {
  let rval = [];
  const traverse = (body, isParentLast) => {
    if (!body || !body.length) return;
    for (const elm of body) {
      let text = elm.text;
      const index = body.indexOf(elm);
      rval.push({indent: elm.indent, text: text});
      traverse(elm.children, index === body.length-1);
      if (index !== body.length-1)
        rval[rval.length-1].text += ';';
      if (index === body.length-2)
        rval[rval.length-1].text += ' and';
    }
  }
  traverse(body, true);
  if (rval.length) rval[rval.length-1].text += '.';
  return rval;
}

// Just takes the flat JSON list and wraps DIVs
Handlebars.registerHelper(
  'renderBodyForClaim',
  function renderBodyForClaim(claim, body, target, doColor) {
    let rval = '';
    const elms = renderBodyToJson(claim, body, target, doColor);
    for (const e of elms) {
      rval += `<div style="margin: 0; text-indent:${e.indent}em">${color(claim, e.text, doColor)}</div>\n`;
    }
    return rval;
  });
    

// Just a nice text preamble
function preambleTXT(claim, doColor) {
  if (claim.claimType === 'ind') {
    return `${claim.claimNum}. A ${color(claim, claim.claimClass, doColor)} ${color(claim, claim.tree.preamble, doColor)}`;
  }
  else {
    let rval = `${claim.claimNum}. The ${claim.claimClass} of claim ${claim.parent.claimNum}, `;
    if (claim.claimType === 'dep/wi') 
      rval += `wherein the ${entity(claim)} ${color(claim, claim.tree.preamble, doColor)}`;
    else
      rval += `${claim.tree.preamble}`;
    if (claim.tree.children.length === 0) rval += '.';
    return rval;
  }
}

Handlebars.registerHelper('claimPreamble', preambleTXT);

const claimTemplateText =`
{{#*inline "render_claim"}}
{{#if claim.makeClaim}}
<div style="margin-top: 1em">
{{~{claimPreamble claim true}}}
</div>
  {{{renderBodyForClaim claim claim.tree.children target true}}}
{{#each claim.children}}
  {{> render_claim claim=this target=../target}}
{{/each}}
{{/if}}
{{/inline}}

<div id='cws-claims'>
{{#if heading}}<h3>{{heading}}</h3>{{/if}}
{{#each claimSet.children}}
  {{> render_claim claim=this target=../target}}
{{/each}}
</div>
`;

export const claimTemplate = Handlebars.compile(claimTemplateText);

const claim2JSON = (claim) => {
  if (!claim.makeClaim) return [];
  let preamble = {indent: 0, text: preambleTXT(claim, false)};
  let list = [ preamble ];
  const body = renderBodyToJson(claim, claim.tree.children, null, false);
  for (const item of body) {
    console.log(item);
    list.push(item);
  }
  for (const childClaim of claim.children) {
    let items = claim2JSON(childClaim);
    list = list.concat(items);
  }
  return list;
}

export const claims2JSON = (claimset) => {
  let list = [];
  for (const claim of claimset.children)
    list = list.concat(claim2JSON(claim));
  return list;
}



